// extracted by mini-css-extract-plugin
export default {"galleryContainer":"styles_galleryContainer__UTjed"};